::ng-deep mat-checkbox .mat-checkbox-layout{align-items:start}::ng-deep mat-checkbox .mat-checkbox-inner-container{top:3px}
/*# sourceMappingURL=archive-dialog.component-3YZ6CDHJ.css.map */
